import { alpha, Theme } from '@mui/material/styles';

export default function OutlinedInput(theme: Theme) {
  return {
    MuiOutlinedInput: {
      styleOverrides: {
        input: {
          padding: '12px 14px',
          '&.Mui-disabled': {
            WebkitTextFillColor: theme.palette.text.secondary,
          },
        },
        notchedOutline: {
          borderColor: theme.palette.divider,
          transition: theme.transitions.create('border-color'),
        },
        root: {
          borderRadius: 10,
          backgroundColor: theme.palette.background.default,
          transition: theme.transitions.create(['border-color', 'box-shadow', 'background-color']),
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: alpha(theme.palette.primary.main, 0.5),
          },
          '&.Mui-focused': {
            boxShadow: `0 0 0 3px ${alpha(theme.palette.primary.main, 0.15)}`,
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: theme.palette.primary.main,
              borderWidth: '1px',
            },
          },
          '&.Mui-error': {
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: theme.palette.error.main,
            },
            '&.Mui-focused': {
              boxShadow: `0 0 0 3px ${alpha(theme.palette.error.main, 0.2)}`,
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: theme.palette.error.main,
                borderWidth: '1px',
              },
            },
          },
          '&.Mui-disabled': {
            backgroundColor: alpha(theme.palette.primary.main, 0.03),
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: theme.palette.divider,
            },
          },
        },
        inputSizeSmall: {
          padding: '8.5px 12px',
        },
        inputMultiline: {
          padding: 0,
        },
      },
    },
  };
}
